import { SelectionEventsRecorded, SelectionAny } from './internal';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionSourceData extends SelectionWithNoteMixin(SelectionAny) {
    getEventsRecorded() {
        return this.get("EVEN" /* Tag.Event */, null, SelectionEventsRecorded);
    }
    getResponsibleAgency() {
        return this.get("AGNC" /* Tag.Agency */);
    }
}
//# sourceMappingURL=SelectionSourceData.js.map